<template>
    <app-layout title="Dashboard">
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Setting
            </h2>
        </template>

        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <section class="text-gray-600 body-font">
                        <div class="container px-5 py-12 mx-auto">
                            <div class="flex flex-wrap -m-2">
                                <div class="p-2 lg:w-1/3 md:w-1/2 w-full hidden">
                                    <div
                                        class="
                                            h-full
                                            flex
                                            items-center
                                            border-grey-200 border
                                            p-4
                                            rounded-lg
                                        "
                                    >
                                        <IconTahunAktif
                                            class="h-14 w-14 mr-4"
                                        />
                                        <div class="flex-grow">
                                            <h2
                                                class="
                                                    text-gray-900
                                                    title-font
                                                    font-bold
                                                    text-sky-600
                                                "
                                            >
                                                <Link
                                                    :href="
                                                        route(
                                                            'setting.tahunaktif'
                                                        )
                                                    "
                                                >
                                                    Tahun Aktif
                                                </Link>
                                            </h2>
                                            <p class="text-gray-500">
                                                Setting tahun aktif aplikasi
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="p-2 lg:w-1/3 md:w-1/2 w-full">
                                    <div
                                        class="
                                            h-full
                                            flex
                                            items-center
                                            border-grey-200 border
                                            p-4
                                            rounded-lg
                                        "
                                    >
                                        <IconJenisPengadaan
                                            class="h-14 w-14 mr-4"
                                        />
                                        <div class="flex-grow">
                                            <h2
                                                class="
                                                    text-gray-900
                                                    title-font
                                                    font-bold
                                                    text-sky-600
                                                "
                                            >
                                                <Link
                                                    :href="
                                                        route(
                                                            'jenispengadaan.index'
                                                        )
                                                    "
                                                >
                                                    Jenis Pengadaan
                                                </Link>
                                            </h2>
                                            <p class="text-gray-500">
                                                Setting jenis pengadaan
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import { defineComponent } from "vue";
import AppLayout from "@/Layouts/AppLayout";
import IconTahunAktif from "@/Icons/TahunAktif";
import IconJenisPengadaan from "@/Icons/JenisPengadaan";
import { Link } from "@inertiajs/inertia-vue3";
import { KeluargaNotif } from "@/constants";

export default defineComponent({
    components: {
        AppLayout,
        Link,
        IconTahunAktif,
        IconJenisPengadaan,
    },
    data() {
        return {
            keluargaNotif: KeluargaNotif,
        };
    },
});
</script>
